module.exports = __webpack_public_path__ + "static/media/ml.29c63802.svg";